/* SHWRA motion + interactions. Lightweight, no dependencies. */
(function () {
  if (window.__shwra) return;
  window.__shwra = true;

  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function ready(fn) {
    if (d.readyState !== 'loading') fn();
    else d.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var reveals = d.querySelectorAll('[data-sh-reveal]');
    if (hasIO && !reduce) {
      root.classList.add('sh-ready');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    var parallax = [].slice.call(d.querySelectorAll('[data-sh-parallax]'));
    var stories = [].slice.call(d.querySelectorAll('[data-sh-story]'));
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      parallax.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-sh-parallax')) || 0;
        var offset = (r.top + r.height / 2 - vh / 2) * k;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      stories.forEach(function (s) {
        var list = s.querySelector('.sh-story__steps');
        if (!list) return;
        var r = list.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / r.height));
        s.style.setProperty('--sh-progress', p.toFixed(3));
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }
    if (!reduce && (parallax.length || stories.length)) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      frame();
    }

    stories.forEach(function (s) {
      var steps = s.querySelectorAll('[data-sh-step]');
      var layers = s.querySelectorAll('[data-sh-layer]');
      if (!hasIO || !steps.length) return;
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = e.target.getAttribute('data-sh-step');
          steps.forEach(function (st) { st.classList.toggle('is-active', st === e.target); });
          layers.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-sh-layer') === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach(function (st) { sio.observe(st); });
    });

    function refreshCart() {
      var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        d.querySelectorAll('.cart-bubble__text-count, [data-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count < 1);
        });
        d.querySelectorAll('.cart-bubble, .cart-count-bubble').forEach(function (el) { el.classList.remove('visually-hidden', 'hidden'); el.hidden = false; });
      }).catch(function () {});
      var drawer = d.querySelector('cart-items-component[data-section-id]');
      if (!drawer) return;
      var sid = drawer.getAttribute('data-section-id');
      fetch(base + '?sections=' + encodeURIComponent(sid)).then(function (r) { return r.json(); }).then(function (json) {
        if (!json || !json[sid]) return;
        var tmp = d.createElement('div');
        tmp.innerHTML = json[sid];
        var fresh = tmp.querySelector('cart-items-component');
        var current = d.querySelector('cart-items-component[data-section-id="' + sid + '"]');
        if (fresh && current) current.replaceWith(fresh);
      }).catch(function () {});
    }

    d.querySelectorAll('[data-sh-buy]').forEach(function (buy) {
      var variants = [];
      try { variants = JSON.parse(buy.querySelector('[data-sh-variants]').textContent); } catch (e) {}
      var slides = buy.querySelectorAll('[data-sh-slide]');
      var thumbs = buy.querySelectorAll('[data-sh-thumb]');
      function show(id) {
        var found = false;
        slides.forEach(function (s) { var on = s.getAttribute('data-sh-slide') === String(id); s.classList.toggle('is-active', on); if (on) found = true; });
        if (!found) return;
        thumbs.forEach(function (t) { var on = t.getAttribute('data-sh-thumb') === String(id); t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-sh-thumb')); }); });

      var idInput = buy.querySelector('[data-sh-id]');
      var priceEl = buy.querySelector('[data-sh-price]');
      var labelEl = buy.querySelector('[data-sh-variant-label]');
      var addBtn = buy.querySelector('[data-sh-add]');
      var addLabel = buy.querySelector('[data-sh-add-label]');
      buy.querySelectorAll('[data-sh-v]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = variants.filter(function (x) { return String(x.id) === btn.getAttribute('data-sh-v'); })[0];
          if (!v) return;
          buy.querySelectorAll('[data-sh-v]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          if (idInput) idInput.value = v.id;
          if (priceEl) priceEl.textContent = v.price;
          if (labelEl) labelEl.textContent = v.title.charAt(0).toUpperCase() + v.title.slice(1).toLowerCase();
          if (addBtn) addBtn.disabled = !v.available;
          if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
          var handle = v.title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          buy.setAttribute('data-sh-variant', handle);
          root.setAttribute('data-sh-variant', handle);
          if (v.image) show(v.image);
        });
      });

      var form = buy.querySelector('[data-sh-form]');
      var added = buy.querySelector('[data-sh-added]');
      var err = buy.querySelector('[data-sh-error]');
      if (form && window.fetch) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); }
          if (err) err.hidden = true;
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
          }).then(function () {
            if (added) { added.hidden = false; }
            if (addLabel) addLabel.textContent = 'Added ✓';
            setTimeout(function () { if (addLabel) addLabel.textContent = 'Add another'; }, 1800);
            refreshCart();
          }).catch(function () {
            if (err) err.hidden = false;
          }).then(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); }
          });
        });
      }
    });

    function syncVariantFromPicker() {
      var checked = d.querySelector('main input[type=radio]:checked[value], main select option:checked');
      if (!checked) return;
      var val = (checked.value || checked.textContent || '').toLowerCase();
      if (/black/.test(val)) root.setAttribute('data-sh-variant', 'black');
      else if (/white/.test(val)) root.setAttribute('data-sh-variant', 'white');
    }
    if (d.querySelector('[data-sh-product-page]')) {
      syncVariantFromPicker();
      d.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('main')) syncVariantFromPicker();
      });
    }
  });
})();
